module.exports = __webpack_public_path__ + "img/gm.7d8d6e69.svg";